// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component_name[data-v-73e5d1ea]{font-weight:bolder;display:inline-block;width:120px}.component_name[data-v-73e5d1ea],.versionStr[data-v-73e5d1ea]{vertical-align:top}.compare_version_header[data-v-73e5d1ea]{text-align:left}", ""]);
// Exports
module.exports = exports;
